import { Provider } from "mobx-react";
/* import { HashRouter as Router, Route, Switch } from "react-router-dom"; */
import React from "react";
import ReactDOM from "react-dom";

import { MatomoProvider, createInstance } from "@datapunt/matomo-tracker-react";

import ErrorBoundary from "./components/error/ErrorBoundary";

//STORES
import HttpServices from "./services/HttpServices";
import UserStore from "./stores/UserStore";
import ContentManagementStore from "./stores/ContentManagementStore";
import DictionaryAdministratorStore from "./stores/DictionaryAdministratorStore";
import SystemAdministratorStore from "./stores/SystemAdministratorStore";
import CreateMappingProjectStore from "./stores/CreateMappingProjectStore";
import CreateFrameworkProjectStore from "./stores/CreateFrameworkProjectStore";
import ExportImportStore from "./stores/ExportImportStore";
import ProjectOwnerStore from "./stores/ProjectOwnerStore";
import MaintenanceAgencyStore from "./stores/MaintenanceAgencyStore";
import CreateUpdateEntityStore from "./stores/CreateUpdateEntityStore";
import CreateBranchStore from "./stores/CreateBranchStorePO";
import ApprovalsChangesStore from "./stores/ApprovalsChangesStore";
import CompareWithStore from "./stores/CompareWithStore";
import ValidationsStore from "./stores/ValidationsStore";
import RestAccessRequestStore from "./stores/RestAccessRequestStore";
import EventSourceStore from "./stores/EventSourceStore";
import AddDictionaryAdminStore from "./stores/AddDictionaryAdminStore";
import ReasignProjectOwnerStore from "./stores/ReasignProjectOwnerStore";
import Exporter from "./services/Exporter";
import Importer from "./services/Importer";
import ChangeSingleFieldValueModalStore from "./stores/ChangeSingleFieldValueModalStore";
import FrameworkComparisonStore from "./stores/FrameworkComparisonStore";
import SearchStore from "./stores/SearchStore";
import DetailViewStore from "./stores/DetailViewStore";
import MemberLinkViewStore from "./stores/MemberLinkViewStore";
import MultiSearchStore from "./stores/MultiSearchStore/MultiSearchStore";
import NavigatorStore from "./stores/NavigatorStore";
import BirdDataTransferStore from "./stores/BirdDataTransferStore";
import BirdHomePageStore from "./stores/BirdHomePageStore";
import GraphicalRepresentationStore from "./stores/GraphicalRepresentationStore";
import CubeQueryWizardStore from "./stores/CubeQueryWizard/CubeQueryWizardStore";
import PreviewStore from "./stores/PreviewStore";
import PopupStore from "./stores/PopupStore";
import NavigationStore from "./stores/NavigationStore";
import UpdateBirdContentStore from "./stores/UpdateBirdContentStore";
import CompareCubeStore from "./stores/CompareCubeStore";
import NotificationStore from "./stores/NotificationStore";

import confirmationModalStore from "./stores/ConfirmationModalStore";

import registerServiceWorker, { unregister } from "./registerServiceWorker";

import App from "./App";

import "./libs/bootstrap/css/bootstrap.min.css";
import "react-toastify/dist/ReactToastify.min.css";
import "react-widgets/dist/css/react-widgets.css";
import "react-datepicker/dist/react-datepicker.css";
import "font-awesome/css/font-awesome.min.css";
import "vis-network/dist/dist/vis-network.min.css";
import "./index.css";
import "./scss/style.scss";

const IS_BIRD_APP = process.env.REACT_APP_ENV === "bird";

const http = new HttpServices();
const userStore = new UserStore(http);
const updateBirdContentStore = new UpdateBirdContentStore(http);
const exporter = new Exporter(http);
const importer = new Importer(http);
const navigationStore = new NavigationStore();
const compareCubeStore = new CompareCubeStore(http);
const contentManagementStore = new ContentManagementStore(
  http,
  exporter,
  importer,
  userStore
);
const projectOwnerStore = new ProjectOwnerStore(
  http,
  contentManagementStore,
  exporter
);
const dictionaryAdministratorStore = new DictionaryAdministratorStore(
  http,
  userStore,
  contentManagementStore
);
const systemAdministratorStore = new SystemAdministratorStore(http, exporter);
const maintenanceAgencyStore = new MaintenanceAgencyStore(http, exporter);
const createMappingProjectStore = new CreateMappingProjectStore(
  http,
  projectOwnerStore
);
const createFrameworkProjectStore = new CreateFrameworkProjectStore(
  http,
  maintenanceAgencyStore
);
const exportImportStore = new ExportImportStore(http, exporter, importer);
const createUpdateEntityStore = new CreateUpdateEntityStore(http);
const createBranchStore = new CreateBranchStore(http);
const approvalsChangesStore = new ApprovalsChangesStore(
  http,
  maintenanceAgencyStore
);
const compareWithStore = new CompareWithStore();
const validationsStore = new ValidationsStore();
const restAccessRequestStore = new RestAccessRequestStore();

const addDictionaryAdminStore = new AddDictionaryAdminStore(
  http,
  projectOwnerStore,
  maintenanceAgencyStore
);
const reasignProjectOwnerStore = new ReasignProjectOwnerStore(
  http,
  projectOwnerStore,
  maintenanceAgencyStore
);
const changeSingleFieldValueModalStore = new ChangeSingleFieldValueModalStore(
  http,
  userStore,
  dictionaryAdministratorStore,
  projectOwnerStore,
  contentManagementStore,
  createFrameworkProjectStore
);
const frameworkComparisonStore = new FrameworkComparisonStore(exporter);

const searchStore = new SearchStore(http, userStore);
const multiSearchStore = new MultiSearchStore(http, searchStore);
const birdDataTransferStore = new BirdDataTransferStore(http, userStore);
const detailViewStore = new DetailViewStore(http, searchStore, exporter);

const memberLinkViewStore = new MemberLinkViewStore(http, searchStore);

const eventSourceStore = new EventSourceStore(
  userStore,
  contentManagementStore,
  searchStore,
  dictionaryAdministratorStore,
  projectOwnerStore,
  maintenanceAgencyStore,
  systemAdministratorStore,
  createMappingProjectStore,
  createFrameworkProjectStore,
  exportImportStore,
  validationsStore
);

const notificationStore = new NotificationStore();
const navigatorStore = new NavigatorStore(http);
const birdHomePageStore = new BirdHomePageStore(http);
const graphicalRepresentationStore = new GraphicalRepresentationStore(http);
const cubeQueryWizardStore = new CubeQueryWizardStore(http, detailViewStore);
const previewStore = new PreviewStore(
  http,
  searchStore,
  exporter,
  navigationStore
);
const popupStore = new PopupStore(http, searchStore, exporter, navigationStore);

const stores = {
  contentManagementStore,
  maintenanceAgencyStore,
  projectOwnerStore,
  createFrameworkProjectStore,
  exportImportStore,
  approvalsChangesStore,
  compareWithStore,
  validationsStore,
  restAccessRequestStore,
  createBranchStore,
  http,
  userStore,
  eventSourceStore,
  dictionaryAdministratorStore,
  createMappingProjectStore,
  systemAdministratorStore,
  reasignProjectOwnerStore,
  addDictionaryAdminStore,
  createUpdateEntityStore,
  confirmationModalStore,
  changeSingleFieldValueModalStore,
  frameworkComparisonStore,
  searchStore,
  detailViewStore,
  memberLinkViewStore,
  multiSearchStore,
  navigatorStore,
  birdDataTransferStore,
  birdHomePageStore,
  graphicalRepresentationStore,
  cubeQueryWizardStore,
  previewStore,
  popupStore,
  navigationStore,
  updateBirdContentStore,
  compareCubeStore,
  notificationStore,
};

const instance = IS_BIRD_APP
  ? createInstance({
      urlBase: "https://ecbdata.matomo.cloud/",
      siteId: 14,
      userId: undefined, // optional, default value: `undefined`.
      trackerUrl: "https://ecbdata.matomo.cloud/matomo.php", // optional, default value: `${urlBase}matomo.php`
      srcUrl: "https://cdn.matomo.cloud/ecbdata.matomo.cloud/matomo.js", // optional, default value: `${urlBase}matomo.js`
      disabled: false, // optional, false by default. Makes all tracking calls no-ops if set to true.
      heartBeat: {
        // optional, enabled by default
        active: true, // optional, default value: true
        seconds: 10, // optional, default value: `15
      },
      linkTracking: false, // optional, default value: true
      configurations: {
        // optional, default value: {}
        // any valid matomo configuration, all below are optional
        disableCookies: true,
        setSecureCookie: true,
        setRequestMethod: "POST",
      },
    })
  : null;

if (!IS_BIRD_APP) {
  document.addEventListener("visibilitychange", function () {
    if (document.visibilityState === "visible") {
      eventSourceStore.func_initializeEventSource();
    } else {
      eventSourceStore.func_unsubscribeEventSource();
    }
  });
}

if (!IS_BIRD_APP) {
  // does not work until we specify return 'something' - but then Chome opens prompt whether to leave the page what is unwanted
  window.onbeforeunload = function () {
    eventSourceStore.func_unsubscribeEventSource();
  };
}

const WithLink = ({ IS_BIRD_APP }) =>
  IS_BIRD_APP ? (
    <MatomoProvider value={instance}>
      <ErrorBoundary>
        <Provider {...stores}>
          <App />
        </Provider>
      </ErrorBoundary>
    </MatomoProvider>
  ) : (
    <ErrorBoundary>
      <Provider {...stores}>
        <App />
      </Provider>
    </ErrorBoundary>
  );

document.addEventListener("DOMContentLoaded", () => {
  ReactDOM.render(
    <WithLink IS_BIRD_APP={IS_BIRD_APP}></WithLink>,
    document.getElementById("root")
  );
});

// we don't want to use service worker as it causes troubles with authentication and between deployments
// (we experienced white page issue with app being unsuccessfully reloaded in a never-ending loop)
let useServiceWorker = false;
if (useServiceWorker) {
  registerServiceWorker();
} else {
  unregister();
}
